import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HomePage } from './home';

@NgModule({
  declarations: [HomePage],
  imports: [
    IonicPageModule.forChild(HomePage)
  ],
})
export class HomePageModule { }



// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts